
(() => {
  const FREE_BESTIE_VARIANT_ID = 49116706767031;

  const QUALIFYING_PRODUCT_IDS = [
    7127537680567,  // Cosette Silver / Original
    15890289950903, // Cosette Gold
    8268342460599,  // Cosette Sterling Silver
    7545035751607,  // Lexi Refillable
    8302571421879,  // Lexi Dual Finish
    1878122627123   // Lexi Sterling Silver
  ];

  let syncing = false;
  let pendingSync = false;
  let syncTimer = null;

  function countQualifyingNecklaces(cart) {
    return cart.items.reduce((total, item) => {
      if (
        QUALIFYING_PRODUCT_IDS.includes(
          Number(item.product_id)
        )
      ) {
        return total + Number(item.quantity);
      }

      return total;
    }, 0);
  }

  function getGiftItem(cart) {
    return cart.items.find(
      item =>
        Number(item.variant_id) ===
        FREE_BESTIE_VARIANT_ID
    );
  }

  async function getFreshCart() {
    const response = await fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Could not load cart');
    }

    return await response.json();
  }

  async function addGift(quantity) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: FREE_BESTIE_VARIANT_ID,
          quantity: quantity
        }]
      })
    });

    if (!response.ok) {
      throw new Error('Could not add free Puppy Besties');
    }
  }

  async function changeGiftQuantity(itemKey, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: itemKey,
        quantity: quantity
      })
    });

    if (!response.ok) {
      throw new Error('Could not update free Puppy Besties');
    }
  }

  function refreshCartUI() {
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true
      })
    );
  }

  async function syncGift() {
    if (syncing) {
      pendingSync = true;
      return;
    }

    syncing = true;

    try {
      do {
        pendingSync = false;

        const cart = await getFreshCart();

        const necklaceQuantity =
          countQualifyingNecklaces(cart);

        const giftItem = getGiftItem(cart);

        const giftQuantity = giftItem
          ? Number(giftItem.quantity)
          : 0;

        if (necklaceQuantity > 0 && !giftItem) {
          await addGift(necklaceQuantity);
          refreshCartUI();
        } else if (giftItem &&
                   giftQuantity !== necklaceQuantity) {
          await changeGiftQuantity(
            giftItem.key,
            necklaceQuantity
          );
          refreshCartUI();
        }
      } while (pendingSync);
    } catch (error) {
      console.error(
        'Free Puppy Bestie gift error:',
        error
      );
    } finally {
      syncing = false;

      if (pendingSync) {
        scheduleSync();
      }
    }
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncGift, 250);
  }

  document.addEventListener(
    'cart:change',
    scheduleSync
  );

  document.addEventListener(
    'DOMContentLoaded',
    scheduleSync
  );

  if (document.readyState !== 'loading') {
    scheduleSync();
  }
})();
